"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameParamsSchema = exports.GameFieldSchema = exports.GameWithRelsParamsSchema = exports.GameWithRelsFieldSchema = void 0;
const zod_1 = require("zod");
const util_1 = require("./util");
const query_1 = require("./query");
const game_1 = require("./game");
const translationQuery_1 = require("./translationQuery");
exports.GameWithRelsFieldSchema = zod_1.z.union((0, util_1.schemaKeys)(game_1.GameWithRelsSchema));
exports.GameWithRelsParamsSchema = (0, query_1.paramsSchema)(exports.GameWithRelsFieldSchema)
    .extend(translationQuery_1.LanguageParamsSchema.shape)
    .strict();
exports.GameFieldSchema = zod_1.z.union((0, util_1.schemaKeys)(game_1.GameSchema));
exports.GameParamsSchema = (0, query_1.paramsSchema)(exports.GameFieldSchema);
//# sourceMappingURL=gameQuery.js.map